import React, { useState } from 'react';
import Milestones from './Milestones';
import WhyChooseUs from './WhyChooseUs';
const About = () => {
  const [activeTab, setActiveTab] = useState('vision');

  const content = {
    vision: "To innovate and deliver cutting-edge technology solutions that empower businesses, enhance digital experiences, and drive global transformation. We strive to be a trusted partner in shaping the future through innovation, security, and efficiency.",
    mission: "We strive to deliver innovative, secure, and scalable IT solutions that empower businesses and enhance digital experiences. With a customer-centric approach and a commitment to quality, we drive digital transformation.",
    goals: "We aim to deliver innovative, secure, and scalable IT solutions that empower businesses and drive digital transformation. Our focus is on customer satisfaction, operational efficiency, and long-term sustainability."
  };

  return (
    <>
      <section className="about-section-new">
        <div className="custom-container">
          <div className="main-flex">

            {/* LEFT CONTENT */}
            <div className="left-side" data-aos="fade-right">
              <h2 className="main-heading">
                Innovating The <br />
                <span>Future of Business</span>
              </h2>

              <p className="sub-text" data-aos="fade-up" data-aos-delay="150">
                Empower your enterprise with our state-of-the-art ERP technology.
                We focus on precision, automation, and seamless integration.
              </p>

              <div className="tab-container" data-aos="fade-up" data-aos-delay="300">
                <div className="tab-menu">
                  <button
                    className={activeTab === 'vision' ? 'tab-link active' : 'tab-link'}
                    onClick={() => setActiveTab('vision')}
                  >
                    Vision
                  </button>
                  <button
                    className={activeTab === 'mission' ? 'tab-link active' : 'tab-link'}
                    onClick={() => setActiveTab('mission')}
                  >
                    Mission
                  </button>
                  <button
                    className={activeTab === 'goals' ? 'tab-link active' : 'tab-link'}
                    onClick={() => setActiveTab('goals')}
                  >
                    Goals
                  </button>
                </div>

                <div className="tab-content-box">
                  <p>{content[activeTab]}</p>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="right-side" data-aos="fade-left">

              <img
                src="/assets/img/a1.png" 
                alt="About Galaxy ERP"
                className="about-cartoon-img"
              />
            </div>


          </div>
        </div>
      </section>
      <Milestones />
      <WhyChooseUs />
    </>

  );
};

export default About;